import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import { deleteProgramme, copyProgramme } from '../../redux/programmeSlice';
import { serverReason } from '../patientTabs/prescriptionHelpers';

// Delete (asked first) and copy of a programme TEMPLATE, shared by the
// doctor's tab and the hospital page so both say the same thing.
export default function useProgrammeActions() {
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();

    const remove = async (programme) => {
        const answer = await Swal.fire({
            title: t('programmes.delete_title'),
            text: t('programmes.delete_text', { name: programme.name }),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: t('programmes.delete_confirm'),
            cancelButtonText: t('programmes.cancel'),
            confirmButtonColor: '#dc2626',
            cancelButtonColor: '#6b7280',
        });
        if (!answer?.isConfirmed) return false;
        const res = await dispatch(deleteProgramme({ programmeId: programme.programmeId }));
        if (deleteProgramme.fulfilled.match(res)) {
            toast.success(t('programmes.deleted'));
            return true;
        }
        toast.error(serverReason(res.payload, t('programmes.delete_failed'), i18n.language));
        return false;
    };

    // `doctorId`: the hospital admin copying into THAT doctor's programmes
    // (the server requires it from the admin); a doctor copies into their own.
    const copy = async (programme, { doctorId } = {}) => {
        const res = await dispatch(copyProgramme({ programmeId: programme.programmeId, doctorId }));
        if (copyProgramme.fulfilled.match(res)) {
            toast.success(doctorId ? t('programmes.copied_to_doctor') : t('programmes.copied'));
            return res.payload?.programme || null;
        }
        toast.error(serverReason(res.payload, t('programmes.copy_failed'), i18n.language));
        return null;
    };

    return { remove, copy };
}
